module.exports = __webpack_public_path__ + "static/media/iazzu-thumbs-setup.0a4cc1ae.jpg";